import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import style from "./index.module.scss";
import WrapperContent from "../../components/shared/WrapperContent";
import { useSelector } from "react-redux";
import HeaderContentNew from "../../components/shared/HeaderContentNew/HeaderContentNew";
import { toast } from "react-toastify";
import { Expeditor } from "../../services";
import AccessDeniedModal from "../../components/shared/SubscriptionModal/AccessDeniedModal";
import InvitePartnerModal from "../../components/partners/components/InvitePartnerModal";
import PartnersItemTable from "../../components/partners/PartnersItemTable";
import InvitationHistoryTable from "../../components/partners/InvitationHistoryTable/InvitationHistoryTable";
import BaseMetrics from "../../components/partners/components/BaseMetrics";
import Loading from "../../components/shared/Loading/Loading";
import EmptyContent from "../../components/shared/emptyContent";

const TABS = {
  PARTNERS: "partners",
  INVITATION_HISTORY: "invitationHistory",
};

const PartnersPage = () => {
  const { t } = useTranslation();
  const { user } = useSelector((state) => state);
  const [activeTab, setActiveTab] = useState(TABS.PARTNERS);
  const [isAddTransportCompany, setAddTransportCompany] = useState(false);
  const [isLoading, setLoading] = useState(false);
  const [isDisplayModal, changeDisplayModal] = useState(false);
  const [partners, setPartners] = useState([]);
  const [partnerIndicators, setPartnerIndicators] = useState({
    active: 0,
    total: 0,
    register: 0,
    confirmed: 0,
  });

  const handleAddClick = () => {
    const isUnlimited = user?.role?.isUnlimited === true;
    const partnerLimit = user?.role?.partnerLimit ?? 0;
    const partnersCount = partners.length;
    const remaining = Math.max(0, partnerLimit - partnersCount);

    const canAddPartner = isUnlimited || remaining > 0;

    if (!user?.permissions?.includes("employer_add")) {
      toast.info(t("common.noAccessSupportMessage"), {
        autoClose: 10000,
      });
      return;
    }

    if (!canAddPartner) {
      changeDisplayModal(true);
      return;
    }

    setAddTransportCompany(true);
  };

  useEffect(() => {
    ListPartners();
    getPartnerIndicators();
  }, []);

  const ListPartners = () => {
    setLoading(true);
    Expeditor.getPartners()
      .then((response) => {
        if (response.status === 200) {
          const filtered = response.data.filter(
            (partner) => !(partner.state === "Confirmed" && !partner.companyName)
          );
          setPartners(filtered);
        } else {
          console.log("Список пуст");
        }
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  };

  const getPartnerIndicators = () => {
    Expeditor.getPartnerIndicators()
      .then((response) => {
        if (response.status === 200) {
          setPartnerIndicators(response.data);
        } else {
          console.log("Не удалось загрузить показатели партнеров");
        }
      })
      .catch((err) => {
        console.log("Ошибка при загрузке показателей партнеров:", err);
      });
  };

  return (
    <>
      <HeaderContentNew
        displayTitle
        title={t("partnersPage.header.title")}
        {...(user?.type === "Client" && {
          practicalTitle: t("partnersPage.header.addButton"),
          practicalTitleTooltip: t("tooltips.inviteNewPartner"),
          onPracticalBtnClick: () => {
            handleAddClick();
          },
        })}
        isPartnersPage
        totalPartners={partnerIndicators.active}
      />

      {user?.type === "Client" && (
        <div className={style.tabsContainer}>
          <button
            className={`${style.tabButton} ${activeTab === TABS.PARTNERS ? style.active : ""}`}
            onClick={() => setActiveTab(TABS.PARTNERS)}
          >
            {t("partnersPage.tabs.partners")}
          </button>
          <button
            className={`${style.tabButton} ${
              activeTab === TABS.INVITATION_HISTORY ? style.active : ""
            }`}
            onClick={() => setActiveTab(TABS.INVITATION_HISTORY)}
          >
            {t("partnersPage.tabs.invitationHistory")}
          </button>
        </div>
      )}

      {activeTab === TABS.PARTNERS && (
        <WrapperContent isGap>
          <BaseMetrics metrics={partnerIndicators} />
          {isLoading ? (
            <Loading inBlock />
          ) : !partners.length ? (
            <>
              <PartnersItemTable
                partners={partners}
                user={user}
                isShowModal={isAddTransportCompany}
                setShowModal={setAddTransportCompany}
                onRefresh={() => {
                  ListPartners();
                  getPartnerIndicators();
                }}
              />
              <EmptyContent />
            </>
          ) : (
            <PartnersItemTable
              partners={partners}
              user={user}
              isShowModal={isAddTransportCompany}
              setShowModal={setAddTransportCompany}
              onRefresh={() => {
                ListPartners();
                getPartnerIndicators();
              }}
            />
          )}
        </WrapperContent>
      )}

      {user?.type === "Client" && activeTab === TABS.INVITATION_HISTORY && (
        <WrapperContent isGap>
          <InvitationHistoryTable />
        </WrapperContent>
      )}

      {isAddTransportCompany && (
        <InvitePartnerModal setShowModal={setAddTransportCompany} user={user} />
      )}

      {isDisplayModal && <AccessDeniedModal onClose={() => changeDisplayModal(false)} />}
    </>
  );
};

export default PartnersPage;
